import { useModalContext } from 'utils/contexts/modal';
import { Modal } from '../types/modal';

export const useHandleOpenModal = (modal: Modal) => {
  const { showModal } = useModalContext();
  return () => {
    showModal(modal);
  };
};
